module.exports = __webpack_public_path__ + "img/icon-recad.f7b9a865.svg";